import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/function';
import { failure, success, Type } from 'io-ts';
import { iotsApplyConfig } from '../config';
import { IOTSType, IoTsURI } from '../hkt';
/**
 *  @since 0.0.1
 */
export const refinement = (T, ref, name) => new Type(name, (x) => T.is(x) && ref(x), (i, c) => {
    const r = T.decode(i);
    if (r._tag === 'Left') {
        return r;
    }
    const v = r.right;
    return ref(v) ? success(v) : failure(i, c);
}, T.encode);
/**
 *  @since 0.0.1
 */
export const predicate = (T, predicate, name) => new Type(name, (x) => T.is(x) && predicate(x), (i, c) => {
    const r = T.decode(i);
    if (r._tag === 'Left') {
        return r;
    }
    const v = r.right;
    return predicate(v) ? success(v) : failure(i, c);
}, T.encode);
/**
 *  @since 0.0.1
 */
export const ioTsRefinedInterpreter = memo(() => ({
    _F: IoTsURI,
    refined: (a, ref, name, config) => env => pipe(a(env).type, type => new IOTSType(iotsApplyConfig(config)(refinement(type, ref, name), env, { type }))),
    constrained: (a, pred, name, config) => env => pipe(a(env).type, type => new IOTSType(iotsApplyConfig(config)(predicate(type, pred, name), env, { type })))
}));
